import React from "react";
import VerifiedTrue from "../../assests/Green.svg";
import VerifiedFalse from "../../assests/Red.svg";

export const VerifyUserIcon = (cell, row) => {
    return row ? (
        <>
            {row?.isDetailsFilled ? (
                <img src={VerifiedTrue} className="max-w-20px mr-2" />
            ) : (
                <img src={VerifiedFalse} className="max-w-20px mr-2" />
            )}
            {row?.isDetailsFilled ? (
                <span>{ " Complete"}</span>
            ) : (
                <span>{ " InComplete"}</span>
            )}
        </>
    ) : (
        <span className="text-muted">N/A</span>
    );
};
  